import { MessageDescriptor } from 'react-intl';

export enum RUBRIC_TYPES {
  DEFAULT = 'default',
  DATE = 'date',
  RANGE_NUMERIC = 'rangeNumeric',
  NUMERIC = 'numeric',
  PERCENTAGE = 'percentage',
}

export interface Facet {
  count?: number;
  name?: string;
  key?: string;
  label?: string;
  included?: boolean;
}

export interface NumericFacet {
  name?: string;
  minValue?: number;
  maxValue?: number;
  count?: number;
  included?: boolean;
}

export interface DefaultRubric {
  name: string;
  label: MessageDescriptor | string;
  facets: Facet[];
  type: RUBRIC_TYPES.DEFAULT | RUBRIC_TYPES.NUMERIC;
  filterName?: string;
}
export interface RangeNumericRubric {
  name: string;
  label: MessageDescriptor | string;
  minValue?: number;
  maxValue?: number;
  type: RUBRIC_TYPES.RANGE_NUMERIC | RUBRIC_TYPES.PERCENTAGE;
  filterName?: string;
  facets?: Facet[];
}
export interface PercentageRubric {
  name: string;
  label: MessageDescriptor | string;
  minValue?: number;
  maxValue?: number;
  type: RUBRIC_TYPES.PERCENTAGE | RUBRIC_TYPES.RANGE_NUMERIC;
  filterName?: string;
  facets?: Facet[];
}
export interface NumericRubric {
  name: string;
  label: MessageDescriptor | string;
  facets: NumericFacet[];
  type: RUBRIC_TYPES.NUMERIC | RUBRIC_TYPES.DEFAULT;
  filterName?: string;
}
export interface DateRubric {
  name: string;
  label: MessageDescriptor | string;
  minValue?: Date;
  maxValue?: Date;
  type: RUBRIC_TYPES.DATE;
  filterName?: string;
  facets?: Facet[];
}

export type Rubric =
  | DefaultRubric
  | RangeNumericRubric
  | PercentageRubric
  | NumericRubric
  | DateRubric;

export type Filters = Rubric[];
